import * as React from "react";
import { ITextProps } from "./interfaces";
import { Typography } from "@material-ui/core";
import { stylesTextSubtitle } from "./styles";

const TextSubtitle: (props: ITextProps) => JSX.Element = (props: ITextProps): JSX.Element => {
    const customStyles: Record<string, string> = stylesTextSubtitle();
    const { children, ...other } = props;

    return (
        <Typography variant="subtitle1" color="secondary" className={customStyles.main} {...other}>
            {children}
        </Typography>
    );
};

export default TextSubtitle;